export default "__VITE_ASSET__j7dTFw0b__"